import { ROLES } from '@/constants/roles';

const routes = [
  {
    path: '/event/:id/stages/edit',
    name: 'event-id-stages-edit',
    component: () => import('./views/EditStages/index.vue'),
    meta: {
      accessList: [ROLES.organization],
    },
  },
];

export default routes;
